import { render, staticRenderFns } from "./coursesDetails.vue?vue&type=template&id=44068a00&scoped=true"
import script from "./coursesDetails.vue?vue&type=script&lang=js"
export * from "./coursesDetails.vue?vue&type=script&lang=js"
import style0 from "./coursesDetails.vue?vue&type=style&index=0&id=44068a00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44068a00",
  null
  
)

export default component.exports